import React from 'react';
import SummaryInfo from "./../components/SummaryInfo";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import hero from '../images/hero.jpg'
import PersonalInfo from '../components/PersonalInfo'
import Skills from '../components/Skills';
import Title from './../components/Title';
import {Helmet} from "react-helmet";
import { SoftSkillsProvider } from '../contexts/softSkills';

export default function About(){

    const useStyles = makeStyles((theme) => ({
        root: {
          flexGrow: 1,
          width:'100%',
          height:'100%',
        //   marginTop:'32vh'
        },
        paper: {
            background:'none',
            padding: theme.spacing(2),
            textAlign: 'left',
            boxShadow:'none',
        }
    }));
    const classes = useStyles();
    return(
        <section className='personalInfo container'>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Mostafa Abdelazeem - About me</title>
                <meta name="description" content="I'm a senior Front-End Developer with 5+ years of experience and Extensive Experience in the Design, Development, and maintenance of the website to fix responsive and other issues, I have Extensive Skills in HTML5, CSS3, Javascript,3D Animation using Three.js, and 2d Animation with GSAP, and Responsive"></meta>
                <meta name="robots" content="index, follow"/>
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Mostafa Abdelazeem" />
                <meta property="og:description" content="I'm a senior Front-End Developer with +5 years of experience and Extensive Experience in the Design, Development, and maintenance of the website to fix responsive and other issues, I have Extensive Skills in HTML5, CSS3, Javascript,3D Animation using Three.js, and 2d Animation with GSAP, and Responsive" />
                <meta property="og:image" content="http://moabdo.netlify.app/static/media/hero.5c32137d.jpg" />
                <meta property="og:url" content="https://moabdo.netlify.app/" />
                <meta property="og:site_name" content="Mostafa Abdelazeem - Portfolio" />
            </Helmet>
            <Grid container >
                <Grid item md={6} sm={12} xs={12} >
                    <SummaryInfo/>
                </Grid>
        
                <Grid item md={6} sm={12} xs={12}>
                    <Paper className={classes.paper}>
                        <div className='summaryImg'>
                            <img src={hero} alt='Mostafa Abdelaziem'/>
                        </div>
                    </Paper>
                </Grid>
        
            </Grid>
            <Grid container style={{marginTop:'30px'}} >
                <Grid item md={6} sm={12} xs={12} className='skillGrid'>
                    <Title title={'My Skills'}/>
                    <SoftSkillsProvider>
                        <Skills/>
                    </SoftSkillsProvider>
                </Grid>
                <Grid item  md={6} sm={12} xs={12} className='infoGrid'>
                    <div className="info"  >
                        <Title title={'Personal Data'}/>
                        <PersonalInfo/>
                    </div>
                </Grid>
        
            </Grid>
        </section>
    )
}